import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box
} from '@mui/material';
import './UserForm/UserForm.css';

const TemplateForm = ({ open, onClose, onSubmit, initialData }) => {
  const getSafeData = (data) => ({
    template_name: (data && typeof data.template_name === 'string') ? data.template_name : '',
    template_html: (data && typeof data.template_html === 'string') ? data.template_html : ''
  });

  const [formData, setFormData] = useState(getSafeData(initialData));

  useEffect(() => {
    setFormData(getSafeData(initialData));
  }, [initialData, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value ?? '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      template_name: formData.template_name || '',
      template_html: formData.template_html || ''
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="user-form-dialog"
    >
      <DialogTitle>
        {initialData && initialData.template_name ? 'Editar Template' : 'Novo Template'}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box className="form-grid">
            <TextField
              name="template_name"
              label="Título"
              value={formData.template_name}
              onChange={handleChange}
              fullWidth
              required
            />
            <TextField
              name="template_html"
              label="HTML"
              value={formData.template_html}
              onChange={handleChange}
              fullWidth
              required
              multiline
              minRows={6}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">
            Cancelar
          </Button>
          <Button type="submit" variant="contained" color="primary">
            {initialData && initialData.template_name ? 'Salvar' : 'Criar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default TemplateForm; 